import { IconUserCircle, mapper } from '@maia/icons';
import { ComponentProps, Suspense } from 'react';
import { Radio as AriaRadio } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import {
  radioIndicator,
  radioIndicatorContainer,
} from '../../../forms/radio/variants';
import { cardStyles } from '../../../patterns/card';
import { Typography } from '../../../atoms/typography/typography';
import { FeaturedIcon, Tag, TagStyleVariants } from '../../../ui';

type Props = {
  reference?: string;
  name: string;
  icon: string;
  tag: { label: string } & TagStyleVariants;
} & ComponentProps<typeof AriaRadio>;

export function InsuranceRadioCard(props: Props) {
  const { reference, name, icon, tag, ...rest } = props;

  return (
    <AriaRadio
      className={cardStyles({
        variant: 'elevated',
        className:
          'group flex items-center px-20 py-24 gap-x-40 cursor-pointer',
      })}
      {...rest}
    >
      <div className="flex items-center gap-x-12">
        <div className={twMerge(radioIndicatorContainer({ size: 'small' }))}>
          <span className={radioIndicator({ size: 'small' })} />
        </div>

        {reference && (
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-info300"
          >
            {reference}
          </Typography>
        )}
      </div>

      <div className="flex items-center gap-x-12 min-w-[236px] flex-1">
        <FeaturedIcon
          icon={mapper(icon)}
          variant="light-square"
          size="sm"
          color="primary"
        />

        <Typography variant="body-xs" weight="medium">
          {name}
        </Typography>
      </div>

      <IconUserCircle className="fill-primaryMain size-24" />

      <Tag {...tag} />
    </AriaRadio>
  );
}
